module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Jamaica.e81b60bd.pdf";